import { TitleAssetsProps } from '@procore/core-react/dist/_typedoc/Title/Title.types.json';
import * as React from 'react';
export default {
  TitleAssetsProps,
  React
};